
/* injects from baggage-loader */

'use strict';

export default class ProjectDonationWizardController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {
		this.$log.log(this.donation);
	}

	getReward() {
		if (this.donation.reward_id && this.rewards) {
			return this.rewards.find(r => r.id === this.donation.reward_id);
		} else {
			return {};
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/project-donation-wizard.controller.js